import { StyleSheet } from 'aphrodite';
import { Layouts } from '../../../web/styles/styles';
import { borderColor, brandPrimary, grayDark, titles } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	charCount: {
		color: grayDark,
		fontSize: 11,
		marginTop: 4,
		textAlign: 'right',
	},
	buttonContainer: {
		...Layouts.horizontalStack(),
		marginTop: 20,
	},
	close: {
		marginLeft: 30,
		marginTop: 3,
	},
	container: {
		...aidaBaseStyles.flexHorizontalCenter,
	},
	header: {
		...aidaBaseStyles.flexHorizontalCenter,
		justifyContent: 'space-between',
		marginBottom: 10,
		position: 'relative',
	},
	mainContainer: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: 320,
		minWidth: 460,
		padding: '0 20px',
	},
	modal: {},
	radioOptionContainer: {
		padding: '4px 0',
	},
	radioLabel: {
		color: '#696969',
	},
	radioOptionsContainer: {
		...aidaBaseStyles.flexCol,
		marginBottom: 16,
	},
	sectionLabel: {
		color: '#aaa',
		fontSize: 11,
		padding: '10px 0 12px',
		textTransform: 'uppercase',
	},
	textarea: {
		border: `1px solid ${borderColor}`,
		borderRadius: 4,
		boxSizing: 'border-box',
		color: brandPrimary,
		fontSize: 14,
		minHeight: 100,
		padding: 12,
		resize: 'vertical',
		width: '100%',
		':focus': {
			borderColor: brandPrimary,
			outline: 'none',
		},
		'::placeholder': {
			color: grayDark,
		},
	},
	title: {
		color: titles,
		fontSize: '18px',
	},
	triggerButton: {
		color: brandPrimary,
		fontSize: 12,
		marginRight: 12,
		textDecoration: 'underline',
		whiteSpace: 'nowrap',
	},
});
